var WebIMApp = require('./component/App');
window.WebIMApp = WebIMApp;
require('./style/index.less')
